import React from 'react';

const formatNumber = (num) => {
  return num.toLocaleString();
};

const SummaryStats = ({ reviews, allReviews }) => {
  const calculateStats = (reviewsData) => {
    if (!reviewsData.length) return {};

    const segments = {};
    let totalRating = 0;
    
    reviewsData.forEach(review => {
      const segment = review.SEGMENT;
      if (!segments[segment]) {
        segments[segment] = {
          count: 0,
          totalRating: 0,
          avgRating: 0
        };
      }
      segments[segment].count++;
      segments[segment].totalRating += review.RATING;
      totalRating += review.RATING;
    });

    Object.keys(segments).forEach(segment => {
      segments[segment].avgRating = (segments[segment].totalRating / segments[segment].count).toFixed(1);
    });

    return {
      totalReviews: reviewsData.length,
      averageRating: (totalRating / reviewsData.length).toFixed(1),
      segments
    };
  };

  const currentStats = calculateStats(reviews);
  const allStats = calculateStats(allReviews);
  
  const getSegmentColor = (segment) => {
    const colors = {
      'General Hotel': '#2563eb',
      'Ski Mountain': '#dc2626', 
      'Aquatopia': '#0891b2',
      'Camelbeach': '#ea580c',
      'Mountain Adventures': '#16a34a'
    };
    return colors[segment] || '#6b7280';
  };

  const renderStars = (rating) => {
    const numRating = parseFloat(rating);
    const fullStars = Math.floor(numRating);
    const hasHalfStar = numRating % 1 >= 0.5;
    
    return (
      <span className="stars-display">
        {'★'.repeat(fullStars)}
        {hasHalfStar ? '☆' : ''}
        {'☆'.repeat(5 - fullStars - (hasHalfStar ? 1 : 0))}
      </span>
    );
  };

  if (!currentStats.totalReviews) {
    return (
      <div className="summary-stats">
        <div className="stats-header">
          <h2>Summary Statistics</h2>
        </div>
        <div className="no-data">No reviews available for statistics.</div>
      </div>
    );
  }

  return (
    <div className="summary-stats">
      <div className="stats-header">
        <h2>Summary Statistics</h2>
      </div>
      
      <div className="overall-stats">
        <div className="stat-card">
          <div className="stat-number">{formatNumber(currentStats.totalReviews)}</div>
          <div className="stat-label">
            {reviews.length === allReviews.length ? 'Total Reviews' : 'Filtered Reviews'}
          </div>
          {reviews.length !== allReviews.length && (
            <div className="stat-sublabel">of {formatNumber(allStats.totalReviews)} total</div>
          )}
        </div>
        
        <div className="stat-card">
          <div className="stat-number">
            {renderStars(currentStats.averageRating)}
            <span className="rating-text">{currentStats.averageRating}</span>
          </div>
          <div className="stat-label">Average Rating</div>
        </div>
      </div>

      <div className="segment-stats">
        <h3>By Business Segment</h3>
        <div className="segment-grid">
          {Object.entries(currentStats.segments).map(([segment, stats]) => (
            <div key={segment} className="segment-card">
              <div 
                className="segment-header"
                style={{ borderLeftColor: getSegmentColor(segment) }}
              >
                <div className="segment-name">{segment}</div>
                <div className="segment-rating">
                  {renderStars(stats.avgRating)}
                  <span className="rating-text">{stats.avgRating}</span>
                </div>
              </div>
              <div className="segment-count">{formatNumber(stats.count)} reviews</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SummaryStats;